import { SET_TURNOS_SELECCIONADOS } from "../ActionTypes";

export const setTurnosSeleccionado = (turnosSeleccionado) => (dispatch) => {
  dispatch({ type: SET_TURNOS_SELECCIONADOS, payload: turnosSeleccionado });
};
